import { Editor } from '@tiptap/core';

interface FillableFieldInteraction {
  span: HTMLSpanElement;
  editor: Editor;
}

const closeIconSize = 28;

export const setupPersonalizationInteractions = ({ span, editor }: FillableFieldInteraction): void => {
  const handleMouseMove = (event: MouseEvent) => {
    const personalizationBoundary = span.getBoundingClientRect();
    const closeIconStartBoundaryStart = personalizationBoundary.right - closeIconSize;

    span.setAttribute('data-hovered', event.clientX > closeIconStartBoundaryStart ? 'close' : 'drag');
  };

  const handlePointerDown = (event: PointerEvent) => {
    const personalizationBoundary = span.getBoundingClientRect();
    const closeIconStartBoundaryStart = personalizationBoundary.right - closeIconSize;

    if (event.clientX > closeIconStartBoundaryStart) {
      const pos = editor.view.posAtDOM(span, 0);
      editor.commands.deleteRange({ from: pos, to: pos + 1 });
      event.stopPropagation();
      event.preventDefault();
    }
  };

  span.addEventListener('mousemove', handleMouseMove);
  span.addEventListener('mouseleave', () => span.removeAttribute('data-hovered'));
  span.addEventListener('dragstart', () => span.classList.add('dragging'));
  span.addEventListener('dragend', () => span.classList.remove('dragging'));
  span.addEventListener('pointerdown', handlePointerDown);
};
